import React from 'react';
import PropTypes from 'prop-types';
import InlineMessage from '@ingka/inline-message';

const StoreOpenOrClosed = ({ storeOpened, afterHoursMessage, title, body }) => {
    if (!storeOpened) return <InlineMessage className="card__closed" title={title} body={body} />;

    return <p className="card__afterHoursMessage">{afterHoursMessage}</p>;
};

StoreOpenOrClosed.propTypes = {
    storeOpened: PropTypes.bool,
    afterHoursMessage: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
};
export default StoreOpenOrClosed;
